import React from 'react'
import Grid from '@material-ui/core/Grid'

import Page from 'components/Page'
import RegisterForm from 'components/Page/TankRegistration/RegisterForm'
import ConfirmationScreen from 'components/Page/TankRegistration/ConfirmationScreen'
import { Error } from 'types'
import { updateCustomerInfo } from 'http/customer'
import { registerTank } from 'http/tank'
import { setLoader } from 'utils/loader'

enum Screen {
  REGISTER_FORM,
  CONFIRMATION_SCREEN,
}

interface State {
  deviceID: string
  shipTo: string
  equipment: string
  customer: any
  hasCustomerBeenEdited: boolean
  hasBeenRegistered: boolean
  registerError: Error | string
  confirmError: Error | string
  screen: Screen
}

class TankRegistration extends React.PureComponent<null, State> {
  public constructor(props: any) {
    super(props)
    this.state = {
      deviceID: '',
      shipTo: '',
      equipment: '',
      customer: null,
      hasCustomerBeenEdited: false,
      hasBeenRegistered: false,
      screen: Screen.REGISTER_FORM,
      registerError: Error.NONE,
      confirmError: Error.NONE,
    }
  }

  private _registerAnother = (): void =>
    this.setState({
      deviceID: '',
      shipTo: '',
      equipment: '',
      customer: null,
      hasCustomerBeenEdited: false,
      hasBeenRegistered: false,
      screen: Screen.REGISTER_FORM,
      registerError: Error.NONE,
      confirmError: Error.NONE,
    })

  private _goToRegisterForm = (): void =>
    this.setState({
      ...this.state,
      screen: Screen.REGISTER_FORM,
    })

  private _handleDeviceIdChange = (evt: React.ChangeEvent<HTMLInputElement>): void => {
    this.setState({
      ...this.state,
      deviceID: evt.currentTarget.value,
    })
  }

  private _handleShipToChange = (evt: React.ChangeEvent<HTMLInputElement>): void => {
    this.setState({
      ...this.state,
      shipTo: evt.currentTarget.value,
    })
  }

  private _handleEquipmentChange = (evt: React.ChangeEvent<HTMLInputElement>): void => {
    this.setState({
      ...this.state,
      equipment: evt.currentTarget.value,
    })
  }

  private _handleRegister = async (): Promise<void> => {
    /////////////////////////////////////////////////
    function lower(obj) {
      for (var prop in obj) {
      if (typeof obj[prop] === 'string') {
        obj[prop] = obj[prop].toLowerCase();
      }
      if (typeof obj[prop] === 'object') {
        lower(obj[prop]);
        }
      }
      return obj;
    }
    
    //////////////////////////////////////////////////
    const { deviceID, shipTo, equipment } = this.state
    console.log("heted in their");
    console.log(this.state);
    setLoader(true)
    let error = Error.NONE
    try {
      let ret = await registerTank(deviceID, shipTo, equipment, true)
      console.log(ret);
      if (ret.messageStatus === 'error') {
        error = Error.UNEXPECTED_ERROR
        if (ret.messageCode === 'DeviceNotFound') {
          error = Error.DEVICE_NOT_FOUND
        } else if (ret.messageCode === 'DeviceAssigned') {
          error = Error.DEVICE_ASSIGNED
        } else if (ret.messageCode === 'CustomerNotFound') {
          error = Error.CUSTOMER_NOT_FOUND
        }
      } else {
        this.setState({
          ...this.state,
          screen: Screen.CONFIRMATION_SCREEN,
          customer: lower(ret.data),
        })
      }
    } catch (error) {
      console.log(error)
      error = Error.NETWORK_ERROR
    }
    this.setState({
      ...this.state,
      registerError: error,
    })
    setLoader(false)
  }

  private _handleCustomerInfoChange = (customer: any): void => {
    this.setState({
      ...this.state,
      hasCustomerBeenEdited: true,
      customer,
    })
  }


  
  private _handleConfirm = async (): Promise<void> => {
    setLoader(true)
    let error = Error.NONE
   const { deviceID, shipTo, hasCustomerBeenEdited, equipment, customer } = this.state;
  console.log("customer constant")
  console.log(customer)
    try {
      if (hasCustomerBeenEdited) {
         console.log("update Customer Info")
        let ret = await updateCustomerInfo(customer.id, customer)
        if (ret.messageStatus === 'error') {
          this.setState({
            ...this.state,
            confirmError: ret.messageCode,
          })
          setLoader(false)
          return
        }
      }
      console.log("register tank")
      let ret = await registerTank(deviceID, shipTo, equipment)
      if (ret.messageStatus === 'error') {
        error = ret.messageCode
      } else {
        this.setState({
          ...this.state,
          hasBeenRegistered: true,
        })
      }
    } catch (error) {
      error = Error.NETWORK_ERROR
    }

    this.setState({
      ...this.state,
      confirmError: error,
    })
    setLoader(false)
  }

  public render(): React.ReactNode {
    const { registerError, confirmError, deviceID, shipTo, equipment, customer, screen, hasBeenRegistered } = this.state
    return (
      <Page title="Register">
        <Grid container justify="center" alignItems="center">
          <Grid container direction="column" item xs={10} md={8} lg={4}>
            {screen === Screen.REGISTER_FORM && (
              <RegisterForm
                error={registerError}
                deviceID={deviceID}
                equipment={equipment}
                shipTo={shipTo}
                handleShipToChange={this._handleShipToChange}
                handleDeviceIdChange={this._handleDeviceIdChange}
                handleEquipmentChange={this._handleEquipmentChange}
                handleRegister={this._handleRegister}
              />
            )}
            {screen === Screen.CONFIRMATION_SCREEN && (
              <ConfirmationScreen
                data={{
                  deviceID,
                  ...customer,
                }}
                error={confirmError}
                registered={hasBeenRegistered}
                registerAnother={this._registerAnother}
                handleCustomerInfoChange={this._handleCustomerInfoChange}
                handleConfirm={this._handleConfirm}
                handleCancel={this._goToRegisterForm}
              />
            )}
          </Grid>
        </Grid>
      </Page>
    )
  }
}

export default TankRegistration
